module.exports = __webpack_public_path__ + "static/media/ic-close-white-20.1326dfec.svg";